// Contract addresses configuration
// Update these after deploying contracts

// USDT contract address on BSC Mainnet
export const USDT_ADDRESS = process.env.REACT_APP_USDT_ADDRESS || '0x55d398326f99059fF775485246999027B3197955';

// NFT Contract address (update after deployment)
export const NFT_CONTRACT_ADDRESS = process.env.REACT_APP_NFT_CONTRACT_ADDRESS || '';

// Contract ABIs
export const USDT_ABI = [
  // approve
  {
    constant: false,
    inputs: [
      { name: '_spender', type: 'address' },
      { name: '_value', type: 'uint256' }
    ],
    name: 'approve',
    outputs: [{ name: '', type: 'bool' }],
    type: 'function'
  },
  // allowance
  {
    constant: true,
    inputs: [
      { name: '_owner', type: 'address' },
      { name: '_spender', type: 'address' }
    ],
    name: 'allowance',
    outputs: [{ name: '', type: 'uint256' }],
    type: 'function'
  },
  // balanceOf
  {
    constant: true,
    inputs: [{ name: '_owner', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: 'balance', type: 'uint256' }],
    type: 'function'
  },
  // decimals
  {
    constant: true,
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', type: 'uint8' }],
    type: 'function'
  }
];

export const NFT_ABI = [
  // owner (Ownable)
  {
    inputs: [],
    name: 'owner',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
  },
  // balanceOf (ERC-721 standard)
  {
    inputs: [{ internalType: 'address', name: 'owner', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  // ownerOf (ERC-721 standard)
  {
    inputs: [{ internalType: 'uint256', name: 'tokenId', type: 'uint256' }],
    name: 'ownerOf',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
  },
  // presaleMint
  {
    inputs: [],
    name: 'presaleMint',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  // publicMint
  {
    inputs: [],
    name: 'publicMint',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  // PRESALE_PRICE (constant)
  {
    inputs: [],
    name: 'PRESALE_PRICE',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  // PUBLIC_PRICE (constant)
  {
    inputs: [],
    name: 'PUBLIC_PRICE',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  // presaleMinted
  {
    inputs: [],
    name: 'presaleMinted',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  // PRESALE_SUPPLY
  {
    inputs: [],
    name: 'PRESALE_SUPPLY',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  // presaleActive
  {
    inputs: [],
    name: 'presaleActive',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function'
  },
  // publicSaleActive
  {
    inputs: [],
    name: 'publicSaleActive',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function'
  },
  // totalSupply
  {
    inputs: [],
    name: 'totalSupply',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  }
];

// USDT decimals (18 on BSC)
export const USDT_DECIMALS = 18;

